module.exports = __webpack_public_path__ + "media/images/latief-signature-5d68f38ef8392e73387cd705cfbc264e.png";